module.exports = __webpack_public_path__ + "pc/img/swiper_bg_01.5d56cbd8.jpg";